import React, { createContext, useContext, useState, useEffect } from 'react';

const UnreadMessagesContext = createContext();

export const useUnreadMessages = () => {
    const context = useContext(UnreadMessagesContext);
    if (!context) {
        throw new Error('useUnreadMessages must be used within UnreadMessagesProvider');
    }
    return context;
};

export const UnreadMessagesProvider = ({ children }) => {
    const [totalUnreadCount, setTotalUnreadCount] = useState(0);
    const [unreadByConversation, setUnreadByConversation] = useState({});

    // Calculer le total des messages non lus
    useEffect(() => {
        const total = Object.values(unreadByConversation).reduce((sum, count) => sum + count, 0);
        setTotalUnreadCount(total);
    }, [unreadByConversation]);

    // Mettre à jour les messages non lus pour une conversation
    const updateUnreadMessages = (conversationId, count) => {
        setUnreadByConversation(prev => {
            const newState = { ...prev };
            if (count > 0) {
                newState[conversationId] = count;
            } else {
                delete newState[conversationId];
            }
            return newState;
        });
    };

    // Marquer une conversation comme lue
    const markConversationAsRead = (conversationId) => {
        setUnreadByConversation(prev => {
            const newState = { ...prev };
            delete newState[conversationId];
            return newState;
        });
    };

    // Ajouter un message non lu
    const addUnreadMessage = (conversationId) => {
        setUnreadByConversation(prev => ({
            ...prev,
            [conversationId]: (prev[conversationId] || 0) + 1
        }));
    };

    // Définir tous les messages non lus d'un coup (pour le chargement initial)
    const setAllUnreadMessages = (unreadCounts) => {
        setUnreadByConversation(unreadCounts);
    };

    const value = {
        totalUnreadCount,
        unreadByConversation,
        updateUnreadMessages,
        markConversationAsRead,
        addUnreadMessage,
        setAllUnreadMessages
    };

    return (
        <UnreadMessagesContext.Provider value={value}>
            {children}
        </UnreadMessagesContext.Provider>
    );
}; 